import { Answer as AnswerModel } from '../../models/Answer'
import { FileOutlined, LinkOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../store/hooks'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import { selectAnswersByIds } from '../../store/AnswerReducer'
import { Actions } from '../../modules/sbrm/components/Actions'
import { List, Space, Tag, Tooltip, Typography } from 'antd'
import { Analytics } from './Analytics'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { Answer } from './Answer'

const { Text, Paragraph } = Typography

interface Props {
  ids?: string[]
  models?: AnswerModel[]
  isEditing?: boolean
}

export const AnswerList = ({ ids, models, isEditing = true }: Props) => {
  const answers = models
    ? models
    : useAppSelector(selectAnswersByIds(ids ?? []))

  return (
    <List
      itemLayout="vertical"
      size="large"
      dataSource={answers}
      renderItem={(answer) => (
        <List.Item key={answer.id}>
          <Answer.Item answer={answer} isEditing={isEditing} />
        </List.Item>
      )}
    />
  )
}

export type AnswerListType = { List: typeof AnswerList }
